import ImgWrapper from "components/global/ImgWrapper";
import dangerCircle from "assets/icons/dangerCircle.svg";
import plusIcon from "assets/icons/plus_secondary.svg";
import dotsHorizontal from "assets/icons/dotsHorizontal.svg";
import userIcon from "assets/icons/userIconWhite.svg";
import { ConnectItem } from "./ManageChannelsStyles";
import lockIcon from "assets/icons/padlock.svg";
import { ConnectedOptions, socialIcons } from "./ManageChannels";
import YoutubeConnectModal from "./YoutubeConnectModal";
import { useMemo } from "react";
import PlatformPhoto from "components/global/PlatformPhoto";
import Spacer from "components/global/Spacer";
import { useHistory } from "react-router-dom";
import useLimitation from "hooks/useLimitation";
import { connect } from "react-redux";

const Channels = ({
  brandId,
  socials,
  platformList,
  handleConnectPlatform,
  handleTokenRefresh,
  handleRemoveChannel,
  toggleShowOptions,
  openOptionId,
  connecting,
  showYoutubeModal,
  setShowYoutubeModal,
  removeSocial,
  active_account,
  user,
}) => {
  const history = useHistory();
  const { privileges } = useLimitation(active_account);
  const youtubeChannel = useMemo(
    () => socials?.find((item) => item?.platform === "youtube"),
    [socials]
  );

  return (
    <>
      {socials?.map((channel, index) => {
        const { platform, page } = channel;
        const optionId = `${platform}_${index + 1}`;

        return (
          <ConnectItem key={index} className="connected">
            <PlatformPhoto>
              <ImgWrapper
                size={3.6}
                imgHeight={"1.6rem"}
                className="imgWrapper"
              >
                <img src={page?.photo || userIcon} alt="avi" />
              </ImgWrapper>
            </PlatformPhoto>
            <div className="text">
              <p className="connected l2 bold username">
                {page?.name ?? page?.username}
              </p>
              <Spacer y={0.3} yMobile={0.1} />
              <div className="flexRow alignCenter">
                <PlatformPhoto>
                  <img
                    src={socialIcons.circle[platform]}
                    className="icon platformImg"
                    alt="icon"
                  />
                </PlatformPhoto>
                <Spacer x={1} xMobile={0.5} />
                {platform === "linkedin" && (
                  <p className="colorBodyText l2 platform">
                    LinkedIn{" "}
                    {page?.category === "personal" ? "profile" : "page"}
                  </p>
                )}
                {platform === "facebook" && (
                  <p className="colorBodyText l2 platform">Facebook</p>
                )}
                {platform === "instagram" && (
                  <p className="colorBodyText l2 platform">Instagram</p>
                )}
                {platform === "twitter" && (
                  <p className="colorBodyText l2 platform">Twitter</p>
                )}
                {platform === "youtube" && (
                  <p className="colorBodyText l2 platform">YouTube</p>
                )}
                {platform === "tiktok" && (
                  <p className="colorBodyText l2 platform">TikTok</p>
                )}
                {platform === "pinterest" && (
                  <p className="colorBodyText l2 platform">Pinterest</p>
                )}
                {platform === "threads" && (
                  <p className="colorBodyText l2 platform">Threads</p>
                )}
                {platform === "meta_threads" && (
                  <p className="colorBodyText l2 platform">Threads</p>
                )}
              </div>
            </div>
            <button
              type="button"
              className={`flexRow alignCenter refreshIndicator${
                !page?.is_access_token_valid ? " active" : ""
              }`}
              onClick={() => {
                if (channel.platform === "youtube") {
                  handleRemoveChannel(channel);
                } else {
                  handleTokenRefresh(channel);
                }
              }}
            >
              <img src={dangerCircle} alt="danger" className="icon" />
              <span className="l2 colorDanger">
                {platform === "youtube" ? "Reconnect" : "Refresh"}
              </span>
            </button>
            <button
              type="button"
              className="toggleOptions"
              onClick={() => {
                toggleShowOptions(optionId);
              }}
            >
              <img src={dotsHorizontal} alt="options" className="icon" />
            </button>
            {openOptionId === optionId && (
              <ConnectedOptions
                handleRefresh={handleTokenRefresh}
                handleRemove={handleRemoveChannel}
                toggleShowOptions={toggleShowOptions}
                channel={channel}
                dataId={optionId}
              />
            )}
          </ConnectItem>
        );
      })}

      {!platformList?.includes("facebook") && (
        <ConnectItem>
          <img
            src={socialIcons.default["facebook"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Facebook page</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() =>
              document
                .querySelector(".connectFacebookInfo")
                .classList.add("show")
            }
            disabled={connecting}
          >
            <img src={plusIcon} alt="connect" width="16px" />
            Connect
          </button>
        </ConnectItem>
      )}

      {!platformList?.includes("linkedin") && (
        <ConnectItem>
          <img
            src={socialIcons.default["linkedin"]}
            className="icon"
            alt="icon"
          />
          <span className="text">LinkedIn profile or page</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() => handleConnectPlatform("linkedin")}
            disabled={connecting}
          >
            <img src={plusIcon} alt="connect" width="16px" />
            Connect
          </button>
        </ConnectItem>
      )}

      {!platformList?.includes("instagram") && (
        <ConnectItem>
          <img
            src={socialIcons.default["instagram"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Instagram Business</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() =>
              document.querySelector(".ConnectToIgPrompt").classList.add("show")
            }
            disabled={connecting}
          >
            <img src={plusIcon} alt="connect" width="16px" />
            Connect
          </button>
        </ConnectItem>
      )}

      {!platformList?.includes("twitter") && (
        <ConnectItem>
          <img
            src={socialIcons.default["twitter"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Twitter</span>
          {privileges?.connectable_channels?.includes("twitter") ? (
            <button
              className="colorGrey1 body-2 connect"
              onClick={() => handleConnectPlatform("twitter")}
              disabled={connecting}
            >
              <img src={plusIcon} alt="connect" width="16px" />
              Connect
            </button>
          ) : (
            <button
              className="lock-btn flexRow alignCenter justifyCenter"
              onClick={() => history.push("/dashboard/plans")}
            >
              <img src={lockIcon} alt="locked" />
              Upgrade
            </button>
          )}
        </ConnectItem>
      )}

      {!platformList?.includes("youtube") && (
        <ConnectItem>
          <img
            src={socialIcons.default["youtube"]}
            className="icon"
            alt="icon"
          />
          <span className="text">YouTube</span>
          {privileges?.connectable_channels?.includes("youtube") ? (
            <button
              className="colorGrey1 body-2 connect"
              // onClick={() => setShowYoutubeModal(true)}
              onClick={() => handleConnectPlatform("youtube")}
              disabled={connecting}
            >
              <img src={plusIcon} alt="connect" width="16px" />
              Connect
            </button>
          ) : (
            <button
              className="lock-btn flexRow alignCenter justifyCenter"
              onClick={() => history.push("/dashboard/plans")}
            >
              <img src={lockIcon} alt="locked" />
              Upgrade
            </button>
          )}
        </ConnectItem>
      )}

      {!platformList?.includes("tiktok") && (
        <ConnectItem>
          <img
            src={socialIcons.default["tiktok"]}
            className="icon"
            alt="icon"
          />
          <p className="text">
            TikTok Business
            <br />
          </p>
          {privileges?.connectable_channels?.includes("tiktok") ? (
            <button
              className="colorGrey1 body-2 connect"
              onClick={() =>
                document
                  .querySelector(".connectTiktokInfo")
                  .classList.add("show")
              }
              disabled={connecting}
            >
              <img src={plusIcon} alt="connect" width="16px" />
              Connect
            </button>
          ) : (
            <button
              className="lock-btn flexRow alignCenter justifyCenter"
              onClick={() => history.push("/dashboard/plans")}
            >
              <img src={lockIcon} alt="locked" />
              Upgrade
            </button>
          )}
        </ConnectItem>
      )}

      {!platformList?.includes("pinterest") && (
        <ConnectItem>
          <img
            src={socialIcons.default["pinterest"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Pinterest profile or page</span>

          {privileges?.connectable_channels?.includes("pinterest") ? (
            <button
              className="colorGrey1 body-2 connect"
              onClick={() => handleConnectPlatform("pinterest")}
              disabled={connecting}
            >
              <img src={plusIcon} alt="connect" width="16px" />
              Connect
            </button>
          ) : (
            <button
              className="lock-btn flexRow alignCenter justifyCenter"
              onClick={() => history.push("/dashboard/plans")}
            >
              <img src={lockIcon} alt="locked" />
              Upgrade
            </button>
          )}
        </ConnectItem>
      )}

      {!platformList?.includes("meta_threads") && (
        <ConnectItem>
          <img
            src={socialIcons.default["meta_threads"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Threads</span>

          {privileges?.connectable_channels?.includes("meta_threads") ? (
            <button
              className="colorGrey1 body-2 connect"
              onClick={() => handleConnectPlatform("meta-thread")}
              disabled={connecting}
            >
              <img src={plusIcon} alt="connect" width="16px" />
              Connect
            </button>
          ) : (
            <button
              className="lock-btn flexRow alignCenter justifyCenter"
              onClick={() => history.push("/dashboard/plans")}
            >
              <img src={lockIcon} alt="locked" />
              Upgrade
            </button>
          )}
        </ConnectItem>
      )}

      <YoutubeConnectModal
        open={showYoutubeModal}
        onClose={() => setShowYoutubeModal(false)}
        removeSocial={removeSocial}
        youtubeChannel={youtubeChannel}
        brandId={brandId}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(Channels);
